"use client";

import React from "react";
import Link from "next/link";
import NextImage from "../../common/NextImage";

export default function LogoV2() {

  // Retrieve dynamic database logo image or fallback to local static assets
  const desktopLogoUrl = "/assets/site/images/dnplogo.png";
  const mobileLogoUrl = "/assets/site/images/dnplogo.png"; // Fallback to main brand logo asset

  return (
    <Link 
      href="/" 
      aria-label="Muthu Metals Homepage"
      className="shrink-0 block hover:opacity-90 active:scale-[0.98] transition-all duration-200"
    >
      {/* Desktop Logo Layout */}
      <div className="hidden sm:block relative w-[140px] h-[42px]">
        <NextImage
          src={desktopLogoUrl}
          alt="Muthu Metals Logo"
          width={125}
          height={42}
          className="object-contain w-full h-full"
          priority
        />
      </div>

      {/* Mobile Logo Layout */}
      <div className="block sm:hidden relative w-[160px] h-[48px] overflow-hidden">
        <NextImage
          src={mobileLogoUrl}
          alt="Muthu Metals Mobile Logo"
          width={130}
          height={48}
          className="object-contain w-full h-full"
          priority
        />
      </div>
    </Link>
  );
}
